// Copyright ©️ 2026 eVolve MEP, LLC

import { useMemo } from 'react';

import { LoadingOverlay } from '@mantine/core';
import type { AgChartOptions } from 'ag-charts-enterprise';
import { AgCharts } from 'ag-charts-react';

type Props = {
  options: AgChartOptions;
  loading: boolean;
  withPadding?: boolean;
  minHeight?: number;
};

export const ChartRenderer = ({ options: parentOptions, loading, withPadding = true, minHeight = 300 }: Props) => {
  const options = useMemo<AgChartOptions>(
    () => ({
      ...parentOptions,
      seriesArea: {
        padding: {
          top: 15,
          left: withPadding ? 40 : undefined,
        },
        ...parentOptions.seriesArea,
      },
    }),
    [parentOptions, withPadding],
  );
  return (
    <>
      <AgCharts options={options} style={{ height: '100%', minHeight }} />
      <LoadingOverlay visible={loading} />
    </>
  );
};
